import { PACKAGE_TYPE, CONTRACTABLE_BUFFER } from "@/lib/constants";
import { gql } from "@apollo/client";
import { values, taxCalculation, isDateRangeIn } from "./helper";

export const typeDef = gql`
  type Right {
    id: ID!
    name: String!
    exercise_term: Int
    exercise_term_unit: Int
    view_term: Int
    view_term_unit: Int
    view_limit_date: String
    validity_start_at: String
    validity_end_at: String
    price: Int
    discount_price: Int
    isSvod: Boolean
    push_rank: Int
    package_type: Int
    discount_description: String
    contractAllowed: Boolean
    rights_control_type: Int
  }
`;

export const resolvers = {
  Right: {
    id: (right) => parseInt(right.id || right.right_id, 10),
    price: (obj) => taxCalculation(values(obj, "price")),
    discount_price: (obj) => taxCalculation(values(obj, "discount_price")),
    isSvod: (obj) => PACKAGE_TYPE["svod"] == values(obj, "package_type"),
    package_type: (obj) => values(obj, "package_type"),
    push_rank: (obj) => values(obj, "push_rank"),
    discount_description: (obj) => values(obj, "discount_description"),
    contractAllowed: (right) => {
      if (right) {
        return isDateRangeIn(
          right?.values?.delivery_start_date,
          right?.values?.delivery_end_date,
          { buffer: CONTRACTABLE_BUFFER, default: true }
        );
      }
      return false;
    },
    rights_control_type: (obj) => values(obj, "rights_control_type"),
  },
};
